import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import React from "react";
import ButtonBoxContainer from "./ButtonBoxContainer";

const Index = () => {
  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{
        top: "auto",
        bottom: 0,
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <ButtonBoxContainer />
        <Box>
          <Typography>
            {new Date().getFullYear()}
            {
              " Copyright © ib-data GmbH. Softwareentwicklung für Architektur und Bauwesen"
            }
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Index;
